import { IFilterMultiSelectOption } from 'transfix-ui'

export const getFilterMultiSelectedValues = (selected: IFilterMultiSelectOption[]) => {
  const selectedValues: string[] = []
  selected.forEach(selectedStatus => {
    if (selectedStatus.selected) {
      selectedValues.push(selectedStatus.value)
    }
  })
  return selectedValues
}
